module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Facturar")])]), _vm._v(" "), _c('v-card-text', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "name": "Nit",
      "label": "Nit",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.nit),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nit", $$v)
      },
      expression: "cliente.nit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Nombre",
      "label": "Nombre"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.nombre),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nombre", $$v)
      },
      expression: "cliente.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Direccion",
      "label": "Dirección"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.direccion),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "direccion", $$v)
      },
      expression: "cliente.direccion"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Referencia",
      "label": "Referencia"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.referencia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "referencia", $$v)
      },
      expression: "cliente.referencia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Departamento",
      "label": "Departamento"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.departamento),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "departamento", $$v)
      },
      expression: "cliente.departamento"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Municipio",
      "label": "Municipio"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.municipio),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "municipio", $$v)
      },
      expression: "cliente.municipio"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "left",
      "label": "Es Ruta"
    },
    model: {
      value: (_vm.esruta),
      callback: function($$v) {
        _vm.esruta = $$v
      },
      expression: "esruta"
    }
  })], 1), _vm._v(" "), (_vm.esruta) ? _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.dias,
      "label": "Día",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.dia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "dia", $$v)
      },
      expression: "cliente.dia"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.semanas,
      "label": "Semana",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.semana),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "semana", $$v)
      },
      expression: "cliente.semana"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "Orden",
      "label": "Orden"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.orden),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "orden", $$v)
      },
      expression: "cliente.orden"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a1c6049"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fcliente.vue
// module id = 428
// module chunks = 1